if (!customElements.get("quick-add-modal")) {
	customElements.define(
		"quick-add-modal",
		class QuickAddModal extends ModalDialog {
			constructor() {
				super();
				this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

				window.addEventListener("keyup", (event) => {
					if (event.code.toUpperCase() === "ESCAPE") this.hide();
				});

				/*window.addEventListener('resize', function () {
					$('.js-media-list').each(function () {
						this.swiper?.destroy();
					});
					$('.js-media-sublist').each(function () {
						this.swiper?.destroy();
					});

					setTimeout(() => {
						subSliderInit(true);
						sliderInit(true);
					}, 200)
				});*/
			}

			hide(preventFocus = false) {
                if (!this.hasAttribute('open')) return;
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);
                this.modalContent.querySelectorAll('.swiper').forEach(el => el.swiper?.destroy(true, true));
                this.modalContent.innerHTML = '';
                if (preventFocus) this.openedBy = null;
                super.hide();
            }

			show(opener) {
				opener.setAttribute("aria-disabled", true);
				opener.classList.add("loading");

				if (opener.querySelector(".loading-overlay__spinner")) {
					opener
						.querySelector(".loading-overlay__spinner")
						.classList.remove("hidden");
				}

				fetch(opener.getAttribute("data-product-url"))
					.then((response) => { if (!response.ok) throw new Error('Product unavailable'); return response.text(); })
					.then((responseText) => {
						const responseHTML = new DOMParser().parseFromString(
							responseText,
							"text/html",
						);
						this.productElement = responseHTML.querySelector(
							'section[id^="MainProduct-"]',
						);
						if (!this.productElement) throw new Error('Product template unavailable');
                        this.modalContent.dataset.virtualDiscount = this.productElement.dataset.virtualDiscount || '0';
                        this.preventDuplicatedIDs();
						this.removeDOMElements();
                        this.prepareQuickViewGallery();
						this.setInnerHTML(
							this.modalContent,
							this.productElement.innerHTML,
							opener,
						);

						if (window.Shopify && Shopify.PaymentButton) {
							Shopify.PaymentButton.init();
						}

						if (window.ProductModel) window.ProductModel.loadShopifyXR();

						this.removeGalleryListSemantic();
						this.updateImageSizes();
						this.preventVariantURLSwitching();
						super.show(opener);
                        this.querySelector('.quick-add-modal__content-wrapper').scrollTop = 0;
                        requestAnimationFrame(() => this.initQuickViewGallery());
					})
                    .catch(() => { window.location.assign(opener.getAttribute('data-product-url')); })
					.finally(() => {
						opener.removeAttribute("aria-disabled");
						opener.classList.remove("loading");

						if (opener.querySelector(".loading-overlay__spinner")) {
							opener
								.querySelector(".loading-overlay__spinner")
								.classList.add("hidden");
						}


					});
			}

            prepareQuickViewGallery() {
                const outer = this.productElement.querySelector('.product__outer');
                if (!outer) return;
                [...outer.classList].filter(name => name.startsWith('product__outer--') || name.startsWith('product__gallery--')).forEach(name => outer.classList.remove(name));
                outer.classList.add('product__outer--single-aside', 'product__gallery--single_aside-mobile');
                this.productElement.querySelectorAll('.product__media-sublist-outer, .product__media-grid-noscript').forEach(el => el.remove());
                const gallery = outer.querySelector('.product__media-list');
                if (!gallery) return;
                gallery.classList.remove('js-media-list-mobile');
                gallery.classList.add('js-media-list', 'swiper');
                if (!gallery.querySelector('.swiper-wrapper')) {
                    const track = document.createElement('div');
                    track.className = 'swiper-wrapper';
                    [...gallery.querySelectorAll('.product__media-item')].forEach(item => track.appendChild(item));
                    gallery.prepend(track);
                }
                gallery.querySelectorAll('.product__media-item').forEach(item => item.classList.add('swiper-slide'));
                gallery.querySelectorAll('img').forEach((img, index) => {
                    img.setAttribute('sizes', '(min-width: 750px) 540px, calc(100vw - 64px)');
                    if (index === 0) img.loading = 'eager';
                });
            }

            initQuickViewGallery() {
                const gallery = this.modalContent.querySelector('.js-media-list');
                if (!gallery || !this.hasAttribute('open') || typeof Swiper === 'undefined') return;
                gallery.swiper?.destroy(true, true);
                new Swiper(gallery, {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    autoHeight: false,
                    speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300,
                    navigation: {
                        nextEl: gallery.querySelector('.swiper-button-next'),
                        prevEl: gallery.querySelector('.swiper-button-prev')
                    },
                    pagination: {el: gallery.querySelector('.product__pagination'), clickable: true}
                });
            }

			setInnerHTML(element, html, opener) {
				element.innerHTML = html;

				// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
				element.querySelectorAll("script").forEach((oldScriptTag) => {
					const newScriptTag = document.createElement("script");
					Array.from(oldScriptTag.attributes).forEach((attribute) => {
						newScriptTag.setAttribute(attribute.name, attribute.value);
					});
					newScriptTag.appendChild(
						document.createTextNode(oldScriptTag.innerHTML),
					);
					oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
				});

				// Read more button
				const moreBtn = document.createElement("a");
				//moreBtn.textContent = `${theme.quickviewMore}`;
				moreBtn.innerHTML = `<span>${theme.quickviewMore}</span><svg class="icon icon-button-arrow" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M6 4.5L10 8.5L6 12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
			</svg>`;
				moreBtn.setAttribute("href", opener.getAttribute("data-product-url"));
				moreBtn.setAttribute(
					"class",
					"product__full-details button button--simple button--arrow",
				);
				if (element.querySelectorAll(".product__info-column") && element.querySelectorAll(".product__info-column").length > 0) {
					element.querySelectorAll(".product__info-column").forEach((el, i) => {
						if (i === 1) {
							el.appendChild(moreBtn);
						}
					});
				} else {
					element.querySelector(".product__info-container").appendChild(moreBtn);
				}
			}

			removeDOMElements() {
                this.productElement.querySelectorAll('.product__inline-video-gallery, .spazioil-early-access, .installment-wrapper, .product__seo-title, .custom-liquid, .shopify-block:not([id*="loox_rating"])').forEach(el => el.remove());
				const modal = this.productElement.querySelector('product-modal');
				if (modal) modal.remove();
				
				const popup = this.productElement.querySelectorAll(".product-popup");
				if (popup)
					popup.forEach((el) => {
						el.remove();
					});

				const reviews = this.productElement.querySelector(
					'[data-block-handle="reviews"]',
				);
				if (reviews) reviews.remove();

				const about = this.productElement.querySelectorAll(".about");
				if (about) about.forEach (el => {
					el.remove();
				})

				const iconText = this.productElement.querySelectorAll(".product__text-icon");
				if (iconText)
					iconText.forEach((el) => {
						el.remove();
				}); 

				const shareButtons =
					this.productElement.querySelector(".share-buttons");
				if (shareButtons) shareButtons.remove();

				const tags = this.productElement.querySelector(".product-tags");
				if (tags) tags.remove();

				const pickupAvailability = this.productElement.querySelector(
					".pickup-availability",
				);
				if (pickupAvailability) pickupAvailability.remove();

				const description = this.productElement.querySelector(
					".product__description",
				);
				if (description) description.remove();

				const recommendations = this.productElement.querySelector(
					".product-recommendations",
				);
				if (recommendations) recommendations.remove();
			}

			preventDuplicatedIDs() {
				const sectionId = this.productElement.dataset.section;
				this.productElement.innerHTML =
					this.productElement.innerHTML.replaceAll(
						sectionId,
						`quickadd-${sectionId}`,
					);
				this.productElement
					.querySelectorAll("variant-selects, variant-radios")
					.forEach((variantSelect) => {
						variantSelect.dataset.originalSection = sectionId;
                        variantSelect.dataset.variantMediaDisplay = 'show_all';
					});
			}

			preventVariantURLSwitching() {
				if (this.modalContent.querySelector("variant-radios,variant-selects")) {
					this.modalContent
						.querySelector("variant-radios,variant-selects")
						.setAttribute("data-update-url", "false");
				}
			}

			removeGalleryListSemantic() {
				const galleryList = this.modalContent.querySelector(
					'[id^="Slider-Gallery"]',
				);
				if (!galleryList) return;

				galleryList.setAttribute("role", "presentation");
				galleryList
					.querySelectorAll('[id^="Slide-"]')
					.forEach((li) => li.setAttribute("role", "presentation"));
			}

			updateImageSizes() {
				const product = this.modalContent.querySelector(".product");
				const desktopColumns = product.classList.contains("product--columns");
				if (!desktopColumns) return;

				const mediaImages = product.querySelectorAll(".product__media img");
				if (!mediaImages.length) return;

				let mediaImageSizes =
					"(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

				if (product.classList.contains("product--medium")) {
					mediaImageSizes = mediaImageSizes.replace("715px", "605px");
				} else if (product.classList.contains("product--small")) {
					mediaImageSizes = mediaImageSizes.replace("715px", "495px");
				}

				mediaImages.forEach((img) =>
					img.setAttribute("sizes", mediaImageSizes),
				);
			}
		},
	);
}
